import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getCategoriesDataView,
    getCategoryState,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import translate from "@insite/client-framework/Translate";
import { CustomCategoryModel } from "@insite/client-framework/Types/ApiModels";
import { StyledButton } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle, GridWidths } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PromotionalContentCardDesign from "@NA/Components/PromotionalContentCardDesign";
import ShopSectionCategoryLink from "@NA/CustomComponents/ShopSectionCategoryLink";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import toggleRewardsDrawer from "@NA/Handlers/ADIRewardsDrawerHandler";
import { MappedLink } from "@NA/Overrides/Widgets/Header/MainNavigation";
import { CustomSettingCollectionModel } from "@NA/Store/CustomTypeModel/CustomSettingCollectionModel";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import React, { useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface ShopSectionStyles {
    shopContainer: GridContainerProps;
    shopFirstGridItem: GridItemProps;
    shopSecondGridItem: GridItemProps;
    shopAllBrands: InjectableCss;
    leftMegaMenuItem: GridItemProps;
    leftMegaMenuLink: LinkPresentationProps;
    rightMegaMenuItem: GridItemProps;
    rightMegaMenuStaticLink: GridItemProps;
    rightNewProductsLink: InjectableCss;
    rightMegaMenuLink: LinkPresentationProps;
    rightMegaMenuChildLink: LinkPresentationProps;
    PromoGridItem: GridItemProps;
    PromoOuterGridItem: GridItemProps;
    PromoImage: LazyImageProps;
    PromoImageDescription: LinkPresentationProps;
    PromoImageDetailInfo: TypographyProps;
    PromoButtonLink: LinkPresentationProps;
    PromoDangerouslyTag?: GridItemProps;
}

export const shopSectionStyles: ShopSectionStyles = {
    shopContainer: {
        css: css`
            > ${GridOffset} {
                width: 100%;
                margin: auto;
            }
        `,
    },
    shopAllBrands: {
        css: css`
         padding-bottom: 10px;
        `,
    },
    shopFirstGridItem: {
        css: css`
            padding: 0px;
            max-width: 20%;
            flex-basis: 20%;
            flex-direction: column;
            border-right: 1px solid ${getColor("common.border")};
            overflow: hidden auto;
            padding-left: 5px;
            min-height: 100%;
            max-height: 100vh;
            height: auto;
            &::-webkit-scrollbar {
                width: 4px;
            }

            .shop-mega-menu-left-grid-item{
                &:focus {
                    ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, null,
                    css` 
                                outline-color: ${ADIColors.darkBlack3};       
                                outline-style: ${getProp("theme.focus.style", "solid")};
                                outline-width: 0px;
                                `,],
                    "min",);
            }}                  
                }
                &:focus-visible {
                    ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, null,
                    css` 
                            outline-color: ${ADIColors.darkBlack3};   
                            outline-style: ${getProp("theme.focus.style", "solid")};
                            outline-width: 1px;
                             `,],
                    "min",);
            }}
                } 
            }
            &::-webkit-scrollbar-track {
                background: ${getColor("common.background")};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${getColor("text.accent")};
                border-radius: 7px;
            }
        `,
    },
    shopSecondGridItem: {
        css: css`
            max-width: 80%;
            flex-basis: 80%;
            padding: 0px 11px;
            height: calc(100vh - 160px);
            overflow: hidden auto;
            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-track {
                background: ${getColor("common.background")};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${getColor("text.accent")};
                border-radius: 7px;
            }
            > li:first-child {
                max-width: 75%;
                flex-basis: 75%;
                padding: 0px 15px;
                font-size: 12px;
                > ul {
                    column-count: 4;
                    column-gap: 20px;
                    > li {
                        -webkit-column-break-inside: avoid;
                        page-break-inside: avoid;
                        break-inside: avoid;
                        line-height: 1.6;
                        font-size: 12px;
                       
                        > a {
                            line-height: normal;
                            span {
                                padding-bottom: 12px;
                             }
                        }
                        &:nth-child(1) {
                            padding-bottom: 0px;
                        }
                        > ul {
                            li {
                                a {
                                    line-height: normal;
                                }
                                &:last-child > a {
                                    span {
                                       padding-bottom: 20px;
                                    }
                                } 
                            }
                            
                        }
                        li a {
                            line-height: normal;
                        }
                        
                    }
                }
            }
              > li:nth-child(2) {
                    max-width: 25%;
                    flex-basis: 25%;
                    padding: 0px;
                    > ${GridItemStyle} {
                        flex-basis: 100%;
                        max-width: 100%;
                        flex-direction: column;
                        > div {
                            color: ${getColor("text.main")};
                            margin-bottom: 30px;
                            img {
                                width: 100%;
                                display: block;
                            }
                            > div > a {
                                font-size: 12px;
                                font-weight: bold;
                                margin-top: 10px;
                                width: 100%;
                                line-height: 1;
                                display: inline-block;
                            }
                            p {
                                padding: 0;
                                font-size: 12px;
                                margin: 0;
                                font-weight: normal;
                                line-height: normal;
                            }
                            > a {
                                display: block;
                                padding: 0;
                                font-size: 12px;
                                font-weight: normal;
                                line-height: 1;
                                text-transform: none;
                                text-decoration: underline;
                            }
                        }
                    }
                }
        `,
    },
    leftMegaMenuItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            width: 100%;
            padding: 5px 15px;
            height: 28px;
            max-height: 28px;
            margin-bottom: 5.5px !important;
            &:hover {
                a {
                    span {
                        color: ${getColor("common.background")} !important;
                    }
                }
            }
        `,
    },
    leftMegaMenuLink: {
        css: css`
            &:focus {
                outline-color: transparent !important;
                outline-style: solid;
                outline-width: 0 !important;
            }
            span {
                color: inherit !important;
                font-size: 12px;
            }
        `,
    },
    rightMegaMenuItem: {},
    rightMegaMenuStaticLink: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            margin: 0 0 10px 0 !important;
            padding: 0px;
            font-weight: bold;
            cursor: pointer;

            > ${StyledButton} {
                > ${TypographyStyle} {
                    color: ${getColor("text.main")};
                }
                &:hover {
                    > ${TypographyStyle} {
                        text-decoration: underline;
                    }
                }
            }
        `,
    },
    rightNewProductsLink: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            margin: -5px 0 0 0 !important;
            padding: 0px;
            font-weight: bold;
            cursor: pointer;
            > ${StyledButton} {
                > ${TypographyStyle} {
                    position: relative;
                    color: ${getColor("text.main")};
                }
                &:hover {
                    > ${TypographyStyle} {
                        text-decoration: underline;
                    }
                }
            }
            > a > span > span:first-child {
                &::before {
                    width: 12px;
                    height: 10px;
                    top: 4px;
                    position: absolute;
                    display: inline-block;
                    clip-path: polygon(100% 0%, 0% 105%, 0% 0%);
                    background-color: ${ADIColors.newPrimary};
                    content: "";
                    text-decoration: none !important;
                }
            }
            > a > span > span:last-child {
                padding-left: 15px;
            }

            & div.deals-link {
                margin-bottom: 10px;
            }
        `,
    },
    rightMegaMenuLink: {
        css: css`
            font-weight: bold;
            font-size: 12px;
            > ${TypographyStyle} {
                color: ${getColor("text.main")};
                padding-bottom: 10px;
                font-size: 12px;
            }
            &:hover {
                span {
                    color: ${getColor("text.main")} !important;
                    text-decoration: underline;
                }
            }
        `,
    },
    rightMegaMenuChildLink: {
        css: css`
            font-weight: normal;
            font-size: 12px;
            > ${TypographyStyle} {
                color: ${getColor("text.main")};
                padding-bottom: 10px;
                font-size: 12px;
            }
            &:hover {
                span {
                    color: ${getColor("text.main")} !important;
                    text-decoration: underline;
                }
            }
            &:focus {
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, null,
                    css` 
                            outline-color: ${ADIColors.darkBlack3};       
                            outline-style: ${getProp("theme.focus.style", "solid")};
                            outline-width: 0px;
                            `,],
                    "min",);
            }}                  
            }
            &:focus-visible {
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, null,
                    css` 
                        outline-color: ${ADIColors.darkBlack3};   
                        outline-style: ${getProp("theme.focus.style", "solid")};
                        outline-width: 1px;
                         `,],
                    "min",);
            }}
            } 
        `,
    },
    PromoGridItem: {
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            flex-direction: column;
        `,
    },
    PromoOuterGridItem: {
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            flex-direction: column;
        `,
    },
    PromoImage: {
        css: css`
            width: 200px;
            height: 200px;
        `,
    },
    PromoImageDescription: {},
    PromoImageDetailInfo: {
        css: css`
            color: ${getColor("text.main")};
            font-size: 12px;
            font-weight: bold;
            text-underline-offset: 2px;
            ${TypographyStyle} {
                color: ${getColor("text.main")};
            }
            &:hover {
                ${TypographyStyle} {
                    color: ${getColor("text.main")};
                }
            }
        `,
    },
    PromoButtonLink: {},
};

interface OwnProps {
    link: MappedLink;
    onHandleClose: Function;
}

const mapStateToProps = (state: CustomApplicationState, OwnProps: OwnProps) => {
    const allCategories = OwnProps?.link?.children?.map(item => getCategoryState(state, item.categoryId).value);
    return {
        toggleDrawer: state.ADIGlobalData.loginDrawerStore.loginDrawer,
        categoriesDataView: getCategoriesDataView(state),
        settingsCollection: getSettingsCollection(state) as unknown as CustomSettingCollectionModel,
        allCategories: allCategories as unknown as CustomCategoryModel[],
    };
};

const mapDispatchToProps = {
    toggleLoginDrawer,
    toggleRewardsDrawer,
};
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const ShopSectionComponent = ({
    link,
    onHandleClose,
    toggleLoginDrawer,
    toggleRewardsDrawer,
    toggleDrawer,
    history,
}: Props) => {
    const [activeChildIndex, setActiveChildIndex] = useState<number | null>(0);
    const [showRightSection, setShowRightSection] = useState<boolean>(false);
    let timeoutId: any = null;
 
    const handleMouseEnter = (index: number, categoryName: string) => {
        if (timeoutId) clearTimeout(timeoutId);
        setActiveChildIndex(index);
        timeoutId = setTimeout(() => {
            setShowRightSection(true);
        }, 100); // 100ms Transition Delay
    };

    const handleMouseLeave = () => {
        if (timeoutId) clearTimeout(timeoutId);
        setShowRightSection(false);
    };

    const redirectToLandingPage = (url: string) => {
        window.location.href = url;
        onHandleClose();
    };

    const shopL1ClickHandler = (shopUrl: string) => {
        if (shopUrl) {
            onHandleClose();
            history.push(shopUrl);
        }
    };
    const styles = shopSectionStyles;

    useEffect(() => {
        if (toggleDrawer) { toggleLoginDrawer({ loginDrawer: false }); }
        toggleRewardsDrawer({ rewardsDrawer: false });
    }, []);

    return (
        <>
            <GridContainer {...styles.shopContainer}>
                <GridItem {...styles.shopFirstGridItem}>
                    {link.children!.map((child: MappedLink, childIndex: number) => (
                        <GridItem
                            className="shop-mega-menu-left-grid-item" tabIndex={0}
                            style={{
                                backgroundColor: activeChildIndex === childIndex ? "#002856" : "initial",
                                cursor: "pointer",
                            }}
                            {...styles.leftMegaMenuItem}
                            width={(12 / link.numberOfColumns!) as GridWidths}
                            key={`${child.title}${childIndex}`}
                            onMouseOver={() => handleMouseEnter(childIndex, child.title)}
                            onMouseLeave={handleMouseLeave}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault(); 
                                    shopL1ClickHandler(child.url);
                                }
                            }}
                            as="li"
                        >
                            <Link
                                className="shop-mega-menu-left-link"
                                tabIndex={-1}
                                {...styles.leftMegaMenuLink}
                                //href={child.url}  // Keep this in case required later
                                onClick={() => shopL1ClickHandler(child.url)}
                                data-category-name={`selectedCategoryName_${child.title}`}
                                style={{
                                    color: activeChildIndex === childIndex ? "#fff" : "#000",
                                    cursor: "pointer",
                                    textDecoration: activeChildIndex === childIndex ? "underline" : "",
                                }}
                            //onClick={() => onHandleClose()}  //// Keep this in case required later
                            >
                                {child.title}
                            </Link>
                        </GridItem>
                    ))}
                </GridItem>
                <GridItem
                    {...styles.shopSecondGridItem}
                    className={`right-parent-grid-item ${showRightSection ? "show-right-section" : ""}`}
                >
                    {link.children &&
                        link.children.map(
                            (child: MappedLink, childIndex: number) =>
                                activeChildIndex === childIndex && (
                                    <>
                                        <GridItem
                                            className="shop-mega-menu-right-grid-item"
                                            key={`${child.title}${childIndex}`}
                                            width={(12 / link.numberOfColumns!) as GridWidths}
                                            {...styles.rightMegaMenuItem}
                                            as="li"
                                            data-category-name={`selectedCategoryName_${child.title}`}
                                            onMouseOver={() => handleMouseEnter(childIndex, child.title)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            {child.children && (
                                                <ul data-test-selector={`linksFor_${child.title}`}>
                                                    <>  <StyledWrapper {...styles.shopAllBrands}>
                                                        <GridItem
                                                            className="shop-mega-menu-right-static-link"
                                                            key={`right-static-link_${childIndex}`}
                                                            {...styles.rightMegaMenuStaticLink}
                                                            as="li"
                                                            data-category-name={`selectedCategoryName_${child.title}`}
                                                            onMouseOver={() =>
                                                                handleMouseEnter(childIndex, child.title)
                                                            }
                                                            onMouseLeave={handleMouseLeave}
                                                        >
                                                            <ShopSectionCategoryLink
                                                                className="shop-mega-menu-static-link"
                                                                link={child}
                                                                data-category-name={`selectedCategoryNameLink_${child.title}`}
                                                                onClick={() => onHandleClose()}
                                                            >
                                                                {translate(`Shop All ${child.title}`)}
                                                            </ShopSectionCategoryLink>
                                                        </GridItem>

                                                        {child.properties["newProductsLink"] ? (
                                                            <GridItem
                                                                className="shop-mega-menu-right-static-link"
                                                                key={`right-static-link_${child.title}_new_products`}
                                                                {...styles.rightNewProductsLink}
                                                                as="li"
                                                            >
                                                                <ShopSectionCategoryLink
                                                                    className="shop-mega-menu-right-link"
                                                                    newLink
                                                                    link={child}
                                                                    extendedStyles={styles.rightMegaMenuLink}
                                                                    data-category-name={`selectedCategoryNameLink_${child.title}`}
                                                                    onClick={() => onHandleClose()}
                                                                >
                                                                    <Typography as="span"></Typography>
                                                                    <Typography as="span">
                                                                        {translate(`New Products`)}
                                                                    </Typography>
                                                                </ShopSectionCategoryLink>
                                                            </GridItem>
                                                        ) : null}
                                                        {child.properties["dealsLink"] ? (
                                                            <GridItem
                                                                className="shop-mega-menu-right-static-link"
                                                                key={`right-static-link_${childIndex}_deals_link`}
                                                                {...styles.rightNewProductsLink}
                                                                as="li"
                                                            >
                                                                <ShopSectionCategoryLink
                                                                    className="shop-mega-menu-static-link"
                                                                    dealsLink
                                                                    link={child}
                                                                    data-category-name={`selectedCategoryNameLink_${child.title}`}
                                                                    onClick={() => redirectToLandingPage(child.properties["dealsLink"])}
                                                                >
                                                                    <Typography as="div" className="deals-link">
                                                                        {translate(`Deals`)}
                                                                    </Typography>
                                                                </ShopSectionCategoryLink>
                                                            </GridItem>
                                                        ) : null}
                                                    </StyledWrapper>

                                                        {child.children.map((leafChild: MappedLink, index: number) => (
                                                            <li key={`secondLvl_${leafChild.title}${index}`}>
                                                                <ShopSectionCategoryLink
                                                                    className="shop-mega-menu-right-link"
                                                                    extendedStyles={styles.rightMegaMenuLink}
                                                                    link={leafChild}
                                                                    data-test-selector={leafChild.title}
                                                                    onClick={() => onHandleClose()}
                                                                >
                                                                    {leafChild.title}
                                                                </ShopSectionCategoryLink>
                                                                {leafChild.children && (
                                                                    <ul
                                                                        data-test-selector={`linksFor_${leafChild.title}`}
                                                                    >
                                                                        {leafChild.children.map(
                                                                            (subLeafChild: MappedLink, index) => (
                                                                                <li
                                                                                    key={`thirdLvl_${leafChild.title}${index}`}
                                                                                >
                                                                                    <ShopSectionCategoryLink
                                                                                        className="shop-mega-menu-right-child-link"
                                                                                        extendedStyles={styles.rightMegaMenuChildLink}
                                                                                        link={subLeafChild}
                                                                                        data-test-selector={
                                                                                            subLeafChild.title
                                                                                        }
                                                                                        onClick={() => onHandleClose()}
                                                                                    >
                                                                                        {subLeafChild.title}
                                                                                    </ShopSectionCategoryLink>
                                                                                </li>
                                                                            ),
                                                                        )}
                                                                    </ul>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </>
                                                </ul>
                                            )}
                                        </GridItem>
                                        <GridItem
                                            as="li"
                                            className="mega-menu-image-item"
                                            key={`mega-menu-image-item_${childIndex}`}
                                            width={(12 / link.numberOfColumns!) as GridWidths}
                                            data-category-name={`selectedCategoryName_${child.title}`}
                                            onMouseOver={() => handleMouseEnter(childIndex, child.title)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <PromotionalContentCardDesign link={child} styles={styles} onHandleClose={onHandleClose} />
                                        </GridItem>
                                    </>
                                ),
                        )}
                </GridItem>
            </GridContainer>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(ShopSectionComponent));
